module.exports = __webpack_public_path__ + "img/53d4aaa.png";